{
  "productionPriceList": [],
  "formProductionPriceList":[],
  "productionPriceListTotalCount": 0,
  "productionPriceListSortExpression":null,
  "productionPriceListFilterExpression":null,
  "productionPriceListPaging": {
    "offset": 50,
    "page": 1
  },
  "showOnlyValidConditions": true
}